// extracted by mini-css-extract-plugin
module.exports = {"container":"TrayItem_container__BaYGf","itemText":"TrayItem_itemText__7bMCv"};